import { ActionIconData, ActionIcons } from "PFComponents/action_icons";
import { Inline } from "PFComponents/containers";
import { Label } from "PFComponents/label";

import { SelectV2Props } from "../select_v2.types";
import css from "./header.module.scss";

type HeaderProps = Pick<SelectV2Props, "label" | "labelIcons" | "required" | "disabled"> & {
  actionIcons: ActionIconData[];
};

export const Header = ({ label, labelIcons, actionIcons, required, disabled }: HeaderProps) => {
  if (!label) {
    return null;
  }

  return (
    <Inline className={css.root} justifyContent="space-between" alignItems="center">
      <Label text={label} required={required} disabled={disabled} icons={labelIcons} />
      <ActionIcons actionIcons={actionIcons} />
    </Inline>
  );
};
